"use client"

import React, { useState, useEffect } from "react"
import api from "../config/api"

const Settings = () => {
  const [settings, setSettings] = useState({
    company_name: "",
    tax_number: "",
    address: "",
    phone: "",
    email: "",
  })
  const [loading, setLoading] = useState(true)
  const [message, setMessage] = useState("")
  const [error, setError] = useState("")

  useEffect(() => {
    loadSettings()
  }, [])

  const loadSettings = async () => {
    try {
      const response = await api.get("/settings")
      setSettings(response.data)
    } catch (error) {
      console.error("Ayarlar yüklenemedi:", error)
    } finally {
      setLoading(false)
    }
  }

  const handleSubmit = async (e) => {
    e.preventDefault()
    setMessage("")
    setError("")

    try {
      await api.put("/settings", settings)
      setMessage("Ayarlar başarıyla kaydedildi")
    } catch (error) {
      setError(error.response?.data?.message || "Kaydetme başarısız")
    }
  }

  if (loading) {
    return React.createElement("div", { className: "loading" }, React.createElement("div", { className: "spinner" }))
  }

  return React.createElement(
    "div",
    { className: "settings-page" },
    React.createElement("h1", null, "Sistem Ayarları"),
    React.createElement(
      "div",
      { className: "card" },
      React.createElement("h2", null, "Şirket Bilgileri"),
      message && React.createElement("div", { className: "success-message" }, message),
      error && React.createElement("div", { className: "error-message" }, error),
      React.createElement(
        "form",
        { onSubmit: handleSubmit },
        React.createElement(
          "div",
          { className: "form-row" },
          React.createElement(
            "div",
            { className: "input-group" },
            React.createElement("label", null, "Şirket Adı"),
            React.createElement("input", {
              type: "text",
              value: settings.company_name || "",
              onChange: (e) => setSettings({ ...settings, company_name: e.target.value }),
            }),
          ),
          React.createElement(
            "div",
            { className: "input-group" },
            React.createElement("label", null, "Vergi Numarası"),
            React.createElement("input", {
              type: "text",
              value: settings.tax_number || "",
              onChange: (e) => setSettings({ ...settings, tax_number: e.target.value }),
            }),
          ),
        ),
        React.createElement(
          "div",
          { className: "input-group" },
          React.createElement("label", null, "Adres"),
          React.createElement("textarea", {
            value: settings.address || "",
            onChange: (e) => setSettings({ ...settings, address: e.target.value }),
            rows: 3,
          }),
        ),
        React.createElement(
          "div",
          { className: "form-row" },
          React.createElement(
            "div",
            { className: "input-group" },
            React.createElement("label", null, "Telefon"),
            React.createElement("input", {
              type: "text",
              value: settings.phone || "",
              onChange: (e) => setSettings({ ...settings, phone: e.target.value }),
            }),
          ),
          React.createElement(
            "div",
            { className: "input-group" },
            React.createElement("label", null, "E-posta"),
            React.createElement("input", {
              type: "email",
              value: settings.email || "",
              onChange: (e) => setSettings({ ...settings, email: e.target.value }),
            }),
          ),
        ),
        React.createElement("button", { type: "submit", className: "btn btn-primary" }, "Kaydet"),
      ),
    ),
  )
}

export default Settings
